import { Grid, Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { decodeQueryParamData } from 'utils/utils';
import { useEffect, useState, useMemo } from 'react';
import SolutionCatalogIcon from 'assets/icons/solutions-catalog';
import DetailPageHeader from 'components/header/DetailPageHeader';
import ListViewAttendanceManagement from './ListViewAttendanceManagement';
import { useGetRecentConversationMutation } from 'store/features/api/apiSlice';

const AttendanceManagement = () => {
	const params = useParams();

	const [leaveManagementList, setLeaveManagementList] = useState([]);

	const [GetQueryV3, { data: queryV3Data, isUninitialized, isLoading }] = useGetRecentConversationMutation();
	const companyCode = useSelector((state) => state.profile.profileData.creatorOrganizationId);

	const paramsData = useMemo(() => {
		if (params?.id) {
			return decodeQueryParamData(params?.id);
		}
	});

	useEffect(() => {
		if (companyCode) {
			GetQueryV3({
				companyCode,
				fieldCodes: ['companyCode'],
				fieldValues: [companyCode],
				name: 'CompanyAttendanceManagement',
			});
		}
	}, [companyCode]);

	useEffect(() => {
		if (queryV3Data?.results?.length > 0) {
			const data = queryV3Data?.results?.map((item) => {
				return {
					marker: item.marker,
					exitTime: item.exitTime,
					overtime: item.overtime,
					entryTime: item.entryTime,
					shiftName: item.shiftName,
					dateString: item.dateString,
					shiftLength: item.shiftLength,
					positionName: item.positionName,
					employeeFullName: item.employeeFullName,
					earliestExitTimeline: item.earliestExitTimeline,
					effectiveWorkingHours: item.effectiveWorkingHours,
				};
			});

			setLeaveManagementList(data);
		}
	}, [queryV3Data]);

	return (
		<Grid container>
			<Grid item xs={12}>
				<DetailPageHeader image={<SolutionCatalogIcon color="#fff" width="20px" height="20px" />} title={paramsData?.processName} />
			</Grid>

			<Grid item xs={12}>
				<Box sx={{ background: '#fff', padding: '20px', borderRadius: '4px' }}>
					<ListViewAttendanceManagement data={leaveManagementList} isLoading={isLoading && !isUninitialized} />
				</Box>
			</Grid>
		</Grid>
	);
};

export default AttendanceManagement;
